import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

// Composant pour le cas isActiveSubmit = true
const ActiveRangeDatePickerField = ({ field, control, setValue }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  let pickerClass = ''
  let defaultRange = null

  if (
    field.VALUE__reponse &&
    field.VALUE__reponse !== undefined &&
    field.VALUE__reponse !== 'null' &&
    field.VALUE__reponse[0] !== undefined &&
    field.VALUE__reponse[0] !== null &&
    field.VALUE__reponse[0] !== 'null' &&
    field.VALUE__reponse[1] !== undefined &&
    field.VALUE__reponse[1] !== null &&
    field.VALUE__reponse[1] !== 'null'
  ) {
    defaultRange = [
      dayjs(field.VALUE__reponse[0], 'DD-MM-YYYY'),
      dayjs(field.VALUE__reponse[1], 'DD-MM-YYYY'),
    ]
  }

  if (isSubmitted) {
    pickerClass = error ? 'input-error' : 'input-success'
  }

  console.log('defaultRange', defaultRange)
  const input_style = field.input_design ? { ...field.input_design } : {}

  const RangePickerRender = ({ onChange = () => {}, value }) => (
    <RangePicker
      className={pickerClass}
      style={input_style}
      format="DD-MM-YYYY"
      value={value}
      onChange={(dates, dateStrings) => {
        onChange(dates)
      }}
    />
  )

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      rules={{ required: field.required }}
      render={({ field: { onChange, value } }) => (
        <RangePickerRender onChange={onChange} value={value} />
      )}
      defaultValue={defaultRange}
    />
  )
}

// Composant pour le cas isActiveSubmit = false
const InactiveRangeDatePickerField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}

  const RangePickerRender = () => <RangePicker style={input_style} />

  return <RangePickerRender />
}

const RangeDatePickerField = ({ field, control, setValue, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveRangeDatePickerField
      field={field}
      control={control}
      setValue={setValue}
    />
  ) : (
    <InactiveRangeDatePickerField field={field} />
  )
}

export default RangeDatePickerField
